/* ==========================================================================
   StackLabDesigns — product form: variant pills, price + availability sync,
   gallery thumbnail swap. Vanilla JS.
   ========================================================================== */
(function () {
  "use strict";

  const money = (cents, format) => {
    // Shopify money format fallback: plain dollars
    return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  };

  document.querySelectorAll("[data-product-root]").forEach((root) => {
    const dataEl = root.querySelector("[data-product-json]");
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const form = root.querySelector("[data-product-form]");
    const idInput = root.querySelector("[data-variant-id]");
    const priceEl = root.querySelector("[data-price]");
    const addBtn = root.querySelector("[data-add-to-cart]");
    const optionGroups = Array.from(root.querySelectorAll("[data-option-position]"));

    function selectedOptions() {
      const opts = [];
      optionGroups.forEach((group) => {
        const pos = parseInt(group.getAttribute("data-option-position"), 10);
        const active = group.querySelector("[data-value].is-active");
        opts[pos - 1] = active ? active.getAttribute("data-value") : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find((v) =>
        v.options.every((o, i) => o === opts[i])
      );
    }

    function render() {
      const opts = selectedOptions();
      const variant = findVariant(opts) || product.variants.find((v) => v.available) || product.variants[0];
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        let html = `<span class="price__regular">${money(variant.price)}</span>`;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = `<span class="price__regular">${money(variant.price)}</span><s class="price__compare">${money(variant.compare_at_price)}</s>`;
          priceEl.classList.add("price--on-sale");
        } else {
          priceEl.classList.remove("price--on-sale");
        }
        priceEl.innerHTML = html;
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute("disabled");
          addBtn.textContent = addBtn.getAttribute("data-default-label") || "Add to cart";
        } else {
          addBtn.setAttribute("disabled", "true");
          addBtn.textContent = "Sold out";
        }
      }

      // swap gallery to the variant's image if it has one
      if (variant.featured_image && variant.featured_image.src) {
        swapMain(variant.featured_image.src);
      }

      // update URL (?variant=)
      try {
        const url = new URL(window.location);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      } catch (e) { /* noop */ }
    }

    // pill clicks
    optionGroups.forEach((group) => {
      group.addEventListener("click", (e) => {
        const pill = e.target.closest("[data-value]");
        if (!pill) return;
        group.querySelectorAll("[data-value]").forEach((p) => p.classList.remove("is-active"));
        pill.classList.add("is-active");
        render();
      });
    });

    /* ------------------------------------------------------- gallery */
    const mainImg = root.querySelector("[data-gallery-main] img");
    const mainWrap = root.querySelector("[data-gallery-main]");
    function swapMain(src) {
      if (!mainImg) return;
      // normalize to a wide version
      const wide = src.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "_900x$1$2");
      mainImg.src = src;
    }
    root.querySelectorAll("[data-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const full = thumb.getAttribute("data-full");
        if (mainImg && full) mainImg.src = full;
        root.querySelectorAll("[data-thumb]").forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });

    render();
  });
})();
